"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4027],{

/***/ 71453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "et": function() { return /* reexport */ useData_useData; },
  "ab": function() { return /* reexport */ hooks_useStructure; }
});

// UNUSED EXPORTS: usePrivateRoute

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/utils/loaders.js
var loadGraphql = function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 76613)).catch(function(e) {
        console.error("[core/utils/loaders] fail to import mixer-graphql", e);
        return {};
    });
};
var loadModules = function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 54965)).catch(function(e) {
        console.error("[core/utils/loaders] fail to import mixer-modules", e);
        return {};
    });
};

;// CONCATENATED MODULE: ./src/utils/getComponents.js




var getComponents = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var data, ref, allModules, children;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = param.data;
                    return [
                        4,
                        loadModules()
                    ];
                case 1:
                    allModules = _state.sent();
                    children = [];
                    return [
                        2,
                        (ref = (data === null || data === void 0 ? void 0 : data.components) || (data === null || data === void 0 ? void 0 : data.serverComponents)) === null || ref === void 0 ? void 0 : ref.reduce(function(result, item) {
                            if (item === null || item === void 0 ? void 0 : item.children) {
                                item.children.forEach(function(child) {
                                    return children.push({
                                        dataSource: (child === null || child === void 0 ? void 0 : child.dataSource) || {},
                                        module: (allModules === null || allModules === void 0 ? void 0 : allModules[child.name]) || {},
                                        multiple: !!child.multiple,
                                        name: child.name,
                                        queryVariables: child.queryVariables || []
                                    });
                                });
                            }
                            if (item.type === "group") {
                                return (0,_to_consumable_array/* default */.Z)(result).concat((0,_to_consumable_array/* default */.Z)(item.components.map(function(param) {
                                    var name = param.name, multiple = param.multiple, queryVariables = param.queryVariables, _dataSource = param.dataSource, dataSource = _dataSource === void 0 ? {} : _dataSource;
                                    return {
                                        dataSource: dataSource,
                                        module: (allModules === null || allModules === void 0 ? void 0 : allModules[name]) || {},
                                        multiple: multiple,
                                        name: name,
                                        queryVariables: queryVariables || []
                                    };
                                })), (0,_to_consumable_array/* default */.Z)(children));
                            }
                            return (0,_to_consumable_array/* default */.Z)(result).concat([
                                {
                                    dataSource: (item === null || item === void 0 ? void 0 : item.dataSource) || {},
                                    module: (allModules === null || allModules === void 0 ? void 0 : allModules[item.name]) || {},
                                    multiple: !!item.multiple,
                                    name: item.name,
                                    queryVariables: item.queryVariables || []
                                }, 
                            ], (0,_to_consumable_array/* default */.Z)(children));
                        }, [])
                    ];
            }
        });
    });
    return function getComponents(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var utils_getComponents = (getComponents);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/graphql-combine-query/dist/index.js
var dist = __webpack_require__(947);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/lodash/defaults.js
var defaults = __webpack_require__(84573);
var defaults_default = /*#__PURE__*/__webpack_require__.n(defaults);
// EXTERNAL MODULE: ../../node_modules/lodash/uniq.js
var uniq = __webpack_require__(75652);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var build_esm = __webpack_require__(48728);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
;// CONCATENATED MODULE: ./src/utils/QueryDefinitionCleaner.js




var QueryDefinitionCleaner = /*#__PURE__*/ function() {
    "use strict";
    function QueryDefinitionCleaner() {
        (0,_class_call_check/* default */.Z)(this, QueryDefinitionCleaner);
        this.definedVariables = [];
        this.definedDefinitions = [];
    }
    (0,_create_class/* default */.Z)(QueryDefinitionCleaner, [
        {
            key: "removeDuplicatedVariables",
            value: function removeDuplicatedVariables(variableDefinitions) {
                var _this = this;
                return variableDefinitions.filter(function(variableDefinition) {
                    var ref, ref1;
                    var variableName = variableDefinition === null || variableDefinition === void 0 ? void 0 : (ref = variableDefinition.variable) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.value;
                    if (!variableName || _this.definedVariables.includes(variableName)) {
                        return false;
                    }
                    _this.definedVariables.push(variableName);
                    return true;
                });
            }
        },
        {
            key: "removeDuplicated",
            value: function removeDuplicated(definition) {
                var ref;
                var definitionKey = "".concat(definition === null || definition === void 0 ? void 0 : definition.kind, "|").concat(definition === null || definition === void 0 ? void 0 : (ref = definition.name) === null || ref === void 0 ? void 0 : ref.value);
                if (this.definedDefinitions.includes(definitionKey)) {
                    return false;
                }
                this.definedDefinitions.push(definitionKey);
                return true;
            }
        },
        {
            key: "clean",
            value: function clean() {
                var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var ref, ref1;
                var definitions = ((ref1 = query === null || query === void 0 ? void 0 : (ref = query.definitions) === null || ref === void 0 ? void 0 : ref.filter(this.removeDuplicated.bind(this))) === null || ref1 === void 0 ? void 0 : ref1.map(function(definition) {
                    var ref;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, definition), {
                        variableDefinitions: (definition === null || definition === void 0 ? void 0 : (ref = definition.variableDefinitions) === null || ref === void 0 ? void 0 : ref.length) ? _this.removeDuplicatedVariables(definition.variableDefinitions) : []
                    });
                })) || [];
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                    definitions: definitions
                });
            }
        }
    ]);
    return QueryDefinitionCleaner;
}();
/* harmony default export */ var utils_QueryDefinitionCleaner = (QueryDefinitionCleaner);

// EXTERNAL MODULE: ./src/utils/logger.js
var logger = __webpack_require__(14463);
;// CONCATENATED MODULE: ./src/utils/buildQuery.js














var keyFromDataSource = function(modules, key) {
    return uniq_default()(modules === null || modules === void 0 ? void 0 : modules.reduce(function(acc, param) {
        var module = param.module, name = param.name, dataSource = param.dataSource;
        var moduleDataSource = (0,_object_spread/* default */.Z)({}, module === null || module === void 0 ? void 0 : module.dataSource, dataSource);
        if (moduleDataSource && (module === null || module === void 0 ? void 0 : module.ssr)) {
            var mappedKeys = Object.values(moduleDataSource).map(function(data) {
                var _obj;
                return _obj = {}, (0,_define_property/* default */.Z)(_obj, key, data[key]), (0,_define_property/* default */.Z)(_obj, "name", name), _obj;
            }).filter(Boolean);
            return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(mappedKeys));
        }
        return acc;
    }, []).flat());
};
var getQueriesVariables = function(structure) {
    var ref, ref1;
    var queriesVariables = (ref = (structure === null || structure === void 0 ? void 0 : structure.components) || (structure === null || structure === void 0 ? void 0 : structure.serverComponents)) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, comp) {
        var ref;
        var childVariables = (ref = comp.components) === null || ref === void 0 ? void 0 : ref.reduce(function(res, item) {
            return (0,_object_spread/* default */.Z)({}, res, (0,build_esm/* parsePlaceholders */.VD)(item === null || item === void 0 ? void 0 : item.queryVariables, structure));
        }, {});
        var parentVariables = (0,build_esm/* parsePlaceholders */.VD)(comp === null || comp === void 0 ? void 0 : comp.queryVariables, structure);
        return (0,_object_spread/* default */.Z)({}, acc, parentVariables, childVariables);
    }, {});
    var _ref = (structure === null || structure === void 0 ? void 0 : structure.route) || {}, filters = _ref.filters, routeVariables = (0,_object_without_properties/* default */.Z)(_ref, [
        "filters"
    ]);
    var ref2 = (structure === null || structure === void 0 ? void 0 : structure.cookies) || {}, location = ref2.location, pmdPromoter = ref2.pmdPromoter, customerId = ref2.customerId, partnerId = ref2.partnerId, searchExperiment = ref2.searchExperiment, magaluExperiment = ref2.magaluExperiment, trackId = ref2.trackId;
    var site = (structure === null || structure === void 0 ? void 0 : structure.site) || "";
    var pagePath = structure === null || structure === void 0 ? void 0 : structure.canonicalPath;
    var userAgent = structure === null || structure === void 0 ? void 0 : structure.userAgent;
    var name = structure === null || structure === void 0 ? void 0 : structure.name;
    routeVariables.pmdPromoter = pmdPromoter;
    routeVariables.customerId = customerId;
    routeVariables.partnerId = partnerId;
    routeVariables.searchExperiment = searchExperiment;
    routeVariables.site = site;
    routeVariables.variationId = routeVariables.productId;
    routeVariables.pagePath = pagePath;
    routeVariables.experiment = magaluExperiment;
    routeVariables.pageName = name;
    routeVariables.userAgent = userAgent;
    routeVariables.bypass = !!routeVariables.bypass;
    routeVariables.ignoreSpellCheck = !!routeVariables.ignoreSpellCheck;
    routeVariables.trackId = trackId;
    routeVariables.channelCode = structure === null || structure === void 0 ? void 0 : (ref1 = structure.config) === null || ref1 === void 0 ? void 0 : ref1.salesChannelId;
    routeVariables.pageSize = routeVariables.pageSize ? Number(routeVariables.pageSize) : undefined;
    if (location) {
        routeVariables.zipCode = location === null || location === void 0 ? void 0 : location.zipCode;
        routeVariables.latitude = parseFloat(location === null || location === void 0 ? void 0 : location.zipCodeLatitude);
        routeVariables.longitude = parseFloat(location === null || location === void 0 ? void 0 : location.zipCodeLongitude);
    }
    if (filters) {
        routeVariables.filters = filters.map(function(param) {
            var type = param.type, value = param.value, values = param.values, min = param.min, max = param.max;
            return {
                max: max,
                min: min,
                type: type,
                value: value,
                values: values
            };
        });
    }
    return defaults_default()(queriesVariables, routeVariables);
};
var getMultipleModulesInfo = function(modules) {
    return modules.reduce(function(acc, module) {
        if (acc[module.name]) {
            var newVariables = acc[module.name].queryVariables.concat(module.queryVariables);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, module.name, {
                queryVariables: newVariables
            }));
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, module.name, {
            queryVariables: module.queryVariables
        }));
    }, {});
};
var buildFragmentsVariables = function(fragments) {
    return fragments === null || fragments === void 0 ? void 0 : fragments.reduce(function(acc, param) {
        var fragment = param.fragments;
        if (fragment) {
            // all fragments will be true if declared
            if (typeof fragment === "string") {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, fragment, true));
            }
            var items = fragment === null || fragment === void 0 ? void 0 : fragment.reduce(function(obj, key) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, obj), (0,_define_property/* default */.Z)({}, key, true));
            }, {});
            return (0,_object_spread/* default */.Z)({}, acc, items);
        }
        return acc;
    }, {});
};
var normalizeQueryValue = function(value) {
    if (value.split("").length > 1 && value !== "other") {
        var parsed = JSON.parse(value);
        return parsed[parsed.length - 1].split("?")[0];
    }
    return value;
};
var buildVariables = function(param) {
    var structure = param.structure, modules = param.modules;
    if (!structure) return {};
    var fragments = keyFromDataSource(modules, "fragments");
    var showFragments = buildFragmentsVariables(fragments);
    var queryVariables = getQueriesVariables(structure);
    if (queryVariables.letter && structure.id === "all-brands") {
        queryVariables.letter = normalizeQueryValue(queryVariables.letter);
    }
    if (queryVariables.limit && structure.id === "all-brands") {
        var ref = structure.query || {}, _page = ref.page, page = _page === void 0 ? 1 : _page;
        queryVariables.offset = (page - 1) * queryVariables.limit;
    }
    logger/* default.debug */.Z.debug("[data source] - build query with variables: ".concat(JSON.stringify(queryVariables, null, 4)));
    return (0,_object_spread/* default */.Z)({}, queryVariables, showFragments);
};
var loadQueries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ids, queries;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ids = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [];
                    return [
                        4,
                        loadGraphql()
                    ];
                case 1:
                    queries = _state.sent();
                    logger/* default.debug */.Z.debug("[data source] - build query within IDs: ".concat(ids));
                    return [
                        2,
                        ids.map(function(query) {
                            return queries[query];
                        })
                    ];
            }
        });
    });
    return function loadQueries() {
        return _ref.apply(this, arguments);
    };
}();
var buildMultipleQueries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var modules, multipleModules, multipleQueriesIds, queriesInfo, queries;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    modules = param.modules;
                    multipleModules = modules.filter(function(module) {
                        return module.multiple;
                    });
                    if (multipleModules.length === 0) return [
                        2,
                        []
                    ];
                    multipleQueriesIds = keyFromDataSource(multipleModules, "query");
                    queriesInfo = getMultipleModulesInfo(modules);
                    return [
                        4,
                        loadGraphql()
                    ];
                case 1:
                    queries = _state.sent();
                    return [
                        2,
                        multipleQueriesIds.reduce(function(acc, param) {
                            var name = param.name, query = param.query;
                            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                {
                                    query: queries[query],
                                    variables: queriesInfo[name].queryVariables
                                }, 
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function buildMultipleQueries(_) {
        return _ref.apply(this, arguments);
    };
}();
var buildQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var modules, cleaner, singleQueries, multipleQueries, rootQuery, singleAdded;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    modules = param.modules;
                    cleaner = new utils_QueryDefinitionCleaner();
                    return [
                        4,
                        loadQueries(keyFromDataSource(modules.filter(function(module) {
                            return !module.multiple;
                        }), "query").map(function(param) {
                            var query = param.query;
                            return query;
                        }))
                    ];
                case 1:
                    singleQueries = _state.sent();
                    return [
                        4,
                        buildMultipleQueries({
                            modules: modules
                        })
                    ];
                case 2:
                    multipleQueries = _state.sent();
                    rootQuery = dist_default()("root");
                    singleAdded = singleQueries.reduce(function(combinedQuery, query) {
                        return query ? combinedQuery.add(cleaner.clean(query)) : combinedQuery;
                    }, rootQuery);
                    return [
                        2,
                        multipleQueries.reduce(function(combinedQuery, param) {
                            var query = param.query, variables = param.variables;
                            return query ? combinedQuery.addN(cleaner.clean(query), variables) : combinedQuery;
                        }, singleAdded)
                    ];
            }
        });
    });
    return function buildQuery(_) {
        return _ref.apply(this, arguments);
    };
}();

/* harmony default export */ var utils_buildQuery = (buildQuery);

// EXTERNAL MODULE: ../../node_modules/next/config.js
var next_config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(next_config);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
;// CONCATENATED MODULE: ./src/utils/requestQuery.js




var requestQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, cookies, query, token, _variables, variables, config, client;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, cookies = ref.cookies, query = ref.query, token = ref.token, _variables = ref.variables, variables = _variables === void 0 ? {} : _variables;
            config = config_default()();
            client = (0,esm.client)({
                config: config,
                cookies: cookies,
                token: token
            });
            return [
                2,
                client.query({
                    query: query,
                    variables: variables
                })
            ];
        });
    });
    return function requestQuery() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var utils_requestQuery = (requestQuery);

;// CONCATENATED MODULE: ./src/hooks/useData/useData.js





var useData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var structure, token, cookies, modules, variables, ref, query, ref1, _data, data, errors, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    structure = param.structure, token = param.token;
                    cookies = structure.cookies;
                    return [
                        4,
                        utils_getComponents({
                            data: structure
                        })
                    ];
                case 1:
                    modules = _state.sent();
                    variables = buildVariables({
                        modules: modules,
                        structure: structure
                    });
                    return [
                        4,
                        utils_buildQuery({
                            modules: modules
                        })
                    ];
                case 2:
                    ref = _state.sent(), query = ref.document;
                    if (!query) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        utils_requestQuery({
                            cookies: cookies,
                            query: query,
                            token: token,
                            variables: variables
                        })
                    ];
                case 3:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    _tmp = {};
                    _state.label = 5;
                case 5:
                    ref1 = _tmp, _data = ref1.data, data = _data === void 0 ? {} : _data, errors = ref1.errors;
                    return [
                        2,
                        {
                            data: data,
                            errors: errors
                        }
                    ];
            }
        });
    });
    return function useData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var useData_useData = (useData);

;// CONCATENATED MODULE: ./src/hooks/useData/index.js


;// CONCATENATED MODULE: ./src/utils/deviceTypeFromUserAgent.js
var deviceTypeFromUserAgent = function() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof userAgent !== "string") return "desktop";
    var isMobileRegEx = /(Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dol(f|ph)in|Skyfire|Zune)/g;
    return isMobileRegEx.test(userAgent) ? "mobile" : "desktop";
};
/* harmony default export */ var utils_deviceTypeFromUserAgent = (deviceTypeFromUserAgent);

;// CONCATENATED MODULE: ./src/utils/isGooglebotFromUserAgent.js
var isGooglebotFromUserAgent = function() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!userAgent || typeof userAgent !== "string") return false;
    var isGooglebotRegEx = /(Googlebot|Storebot-Google|GoogleOther|APIs-Google|AdsBot-Google|Mediapartners-Google|FeedFetcher-Google|Google-Read-Aloud|Google-Site-Verification|Google Favicon)/g;
    return isGooglebotRegEx.test(userAgent);
};
/* harmony default export */ var utils_isGooglebotFromUserAgent = (isGooglebotFromUserAgent);

;// CONCATENATED MODULE: ./src/hooks/useStructure.js









var useStructure = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ref, ref1, ref2, ref3, userAgent, themeSuffix, uri, params, query, siteId, routeId, device, isGooglebot, ssr, _resolvedUrl, resolvedUrl, config, structure, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    ref3 = (ctx === null || ctx === void 0 ? void 0 : (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.headers) || {}, userAgent = ref3["user-agent"], themeSuffix = ref3["mixer-theme-id"];
                    uri = ctx.resolvedUrl, params = ctx.params, query = ctx.query, siteId = ctx.siteId, routeId = ctx.routeId;
                    device = utils_deviceTypeFromUserAgent(userAgent);
                    isGooglebot = utils_isGooglebotFromUserAgent(userAgent);
                    ssr = !((ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.url) === null || ref2 === void 0 ? void 0 : ref2.includes("_next/data")); // Ex: on router.push
                    _resolvedUrl = ctx.resolvedUrl, resolvedUrl = _resolvedUrl === void 0 ? null : _resolvedUrl;
                    config = config_default()();
                    return [
                        4,
                        (0,build_esm/* builder */.fl)({
                            config: config,
                            params: params,
                            query: query,
                            routeId: routeId,
                            siteId: siteId,
                            themeSuffix: themeSuffix,
                            uri: uri,
                            userAgent: userAgent
                        })
                    ];
                case 1:
                    structure = _state.sent();
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, structure), {
                            device: device,
                            isGooglebot: isGooglebot,
                            resolvedUrl: resolvedUrl,
                            ssr: ssr
                        })
                    ];
                case 2:
                    e = _state.sent();
                    logger/* default.error */.Z.error("[useStructure] - cannot get structure", e);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function useStructure(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var hooks_useStructure = (useStructure);

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var lodash_get = __webpack_require__(72579);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ./src/hooks/usePrivateRoute.js



var usePrivateRoute = function(structure) {
    if (whereAmI.onServer) return;
    useEffect(function() {
        var ref, ref1;
        var loggedUserDataPath = structure === null || structure === void 0 ? void 0 : (ref = structure.config) === null || ref === void 0 ? void 0 : ref.loggedUser;
        var loginUrl = structure === null || structure === void 0 ? void 0 : (ref1 = structure.config) === null || ref1 === void 0 ? void 0 : ref1.loginUrl;
        if (structure.private && loggedUserDataPath && loginUrl) {
            var loggedUser = get(structure, loggedUserDataPath);
            if (!(loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.id)) {
                window.location.href = loginUrl + window.location.href;
            }
        }
    }, [
        JSON.stringify(structure)
    ]);
};
/* harmony default export */ var hooks_usePrivateRoute = ((/* unused pure expression or super */ null && (usePrivateRoute)));

;// CONCATENATED MODULE: ./src/hooks/index.js





/***/ }),

/***/ 36182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5163);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14463);




var HEADERS_TO_REMOVE = [
    "host",
    "connection",
    "content-length",
    "transfer-encoding",
    "expect",
    "upgrade",
    "user-agent",
    "accept-encoding",
    "keep-alive",
    "proxy-authenticate",
    "proxy-authorization",
    "referer",
    "x-forwarded-for", 
];
var sanitizeHeaders = function(headers) {
    if (!headers) {
        return undefined;
    }
    var sanitized = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, headers);
    HEADERS_TO_REMOVE.forEach(function(header) {
        var lowerCaseKey = Object.keys(sanitized).find(function(key) {
            return key.toLowerCase() === header;
        });
        if (lowerCaseKey) {
            delete sanitized[lowerCaseKey];
        }
    });
    return sanitized;
};
var fetchExternalHtml = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var url, headers, response, html, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, headers = param.headers;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, {
                            headers: sanitizeHeaders(headers),
                            keepalive: true
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new Error("".concat(response.statusText));
                    }
                    return [
                        4,
                        response.text()
                    ];
                case 3:
                    html = _state.sent();
                    return [
                        2,
                        {
                            html: html
                        }
                    ];
                case 4:
                    error = _state.sent();
                    _logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("[fetchExternalHtml] error trying get ".concat(url), error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchExternalHtml(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (fetchExternalHtml);


/***/ }),

/***/ 50161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94843);


var check = function(srcString, data) {
    return Boolean(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, srcString, false));
};
var foundCheck = function() {
    var structure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var span = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_1__/* .trace.getActiveSpan */ .g.getActiveSpan();
    if (!structure.foundCheck) return true;
    if (typeof structure.foundCheck === "string") return check(structure.foundCheck, data);
    if (!Array.isArray(structure.foundCheck)) {
        span === null || span === void 0 ? void 0 : span.addEvent("mixer.error.foundCheck", {
            "log.message": "Not found required data from ".concat(structure === null || structure === void 0 ? void 0 : structure.name, " page"),
            "log.severity": "error"
        });
        return true;
    }
    return structure.foundCheck.every(function(srcString) {
        if (typeof srcString !== "string") {
            span === null || span === void 0 ? void 0 : span.addEvent("mixer.error.foundCheck", {
                "log.message": "Not found required data from ".concat(structure === null || structure === void 0 ? void 0 : structure.name, " page"),
                "log.severity": "error"
            });
            return true;
        }
        return check(srcString, data);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (foundCheck);


/***/ }),

/***/ 35536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/* ###########################################
# Use any text to match with code or reason,
# or a fully object to match with other params
# 
#  Single text example (match code or reason):
# foundError: "SUBREQUEST_HTTP_ERROR"
#
# Match error from service
# foundError: {
#   "service": "beehive"
#   "reason": "request timed out"
# }
#
# Match any error from service
# foundError: {
#   "service": "beehive"
# }
############################################# */ 
var deepFoundCode = function(extension, testData) {
    if (extension === null || extension === void 0 ? void 0 : extension.extensions) return deepFoundCode(extension.extensions, testData);
    if (typeof testData === "string") return (extension === null || extension === void 0 ? void 0 : extension.code) === testData || (extension === null || extension === void 0 ? void 0 : extension.reason) === testData;
    if (Array.isArray(testData)) return testData.some(function(test) {
        return deepFoundCode(extension, test);
    });
    return Object.entries(testData).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return (extension === null || extension === void 0 ? void 0 : extension[key]) === value;
    });
};
var foundError = function(structure, errors) {
    if (Array.isArray(errors)) {
        var hasError = errors.find(function(error) {
            if (!structure.foundError) return false;
            return deepFoundCode(error.extensions, structure.foundError);
        });
        if (hasError) {
            var ref, ref1, ref2, ref3;
            var message = (hasError === null || hasError === void 0 ? void 0 : hasError.message) || ((ref = hasError.extensions) === null || ref === void 0 ? void 0 : (ref1 = ref.exception) === null || ref1 === void 0 ? void 0 : ref1.message);
            throw new Error("".concat((hasError === null || hasError === void 0 ? void 0 : (ref2 = hasError.extensions) === null || ref2 === void 0 ? void 0 : ref2.service) || (hasError === null || hasError === void 0 ? void 0 : (ref3 = hasError.path) === null || ref3 === void 0 ? void 0 : ref3.join("/")), " - ").concat(message));
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (foundError);


/***/ }),

/***/ 11957:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var notFoundPages = [
    "/404/",
    "/notfound/"
];
var isNotFound = function(structure) {
    return (structure === null || structure === void 0 ? void 0 : structure.id) === "404" && !notFoundPages.includes(structure === null || structure === void 0 ? void 0 : structure.resolvedUrl);
};
/* harmony default export */ __webpack_exports__["Z"] = (isNotFound);


/***/ }),

/***/ 14463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd)(next_config__WEBPACK_IMPORTED_MODULE_0___default()()));


/***/ }),

/***/ 66480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94843);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48728);





var removeSlugFromCtxQuery = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.entries(query).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 1), entry = _param[0];
        return entry !== "slug";
    });
};
var redirectCanonicalUrl = function(logger) {
    return function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ctx = ref.ctx, structure = ref.structure, data = ref.data;
        var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
        var span = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_4__/* .trace.getActiveSpan */ .g.getActiveSpan();
        var _canonicalPath = structure.canonicalPath, canonicalPath = _canonicalPath === void 0 ? "" : _canonicalPath, _canonicalUrl = structure.canonicalUrl, canonicalUrl = _canonicalUrl === void 0 ? "" : _canonicalUrl, ssr = structure.ssr;
        var queries = removeSlugFromCtxQuery(ctx === null || ctx === void 0 ? void 0 : ctx.query);
        var canonical = (0,_magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_2__/* .parsePlaceholders */ .VD)(canonicalUrl, data).toLowerCase();
        var resolvedPath = canonical && (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .parseCanonical */ .$f)(canonical);
        if (canonical && canonicalPath && canonicalUrl && !canonicalPath.includes(resolvedPath) && canonical !== canonicalUrl) {
            var ref1;
            var canonicalDomain = (structure === null || structure === void 0 ? void 0 : (ref1 = structure.config) === null || ref1 === void 0 ? void 0 : ref1.canonicalDomain) && (0,_magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_2__/* .parsePlaceholders */ .VD)(structure.config.canonicalDomain, {
                config: publicRuntimeConfig
            }).toLowerCase();
            var resolvedUrl = new URL(resolvedPath, canonicalDomain);
            resolvedUrl.search = new URLSearchParams(queries);
            var path = "".concat(resolvedUrl.pathname).concat(resolvedUrl.search);
            if (!ssr) {
                return {
                    props: {
                        redirect: path
                    }
                };
            }
            span === null || span === void 0 ? void 0 : span.addEvent("mixer.redirect.to.canonicals", {
                "log.message": "Redirect to canonical ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl),
                "log.severity": "info"
            });
            logger.info("[Core] Redirecting to canonical from url: ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl));
            ctx.res.writeHead(301, {
                Location: path
            });
            ctx.res.end();
        }
        return null;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (redirectCanonicalUrl);


/***/ }),

/***/ 65885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48728);

var redirectFromEmpty = function(logger) {
    return function(param) {
        var ctx = param.ctx, structure = param.structure, data = param.data;
        var redirectIfEmptyData = structure.redirectIfEmptyData, ssr = structure.ssr;
        var shouldRedirect = data[redirectIfEmptyData === null || redirectIfEmptyData === void 0 ? void 0 : redirectIfEmptyData.originData];
        var path = (0,_magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_0__/* .parsePlaceholders */ .VD)(redirectIfEmptyData === null || redirectIfEmptyData === void 0 ? void 0 : redirectIfEmptyData.to, structure);
        if (path && !shouldRedirect) {
            if (!ssr) {
                return {
                    props: {
                        redirect: path
                    }
                };
            }
            logger.debug("[Core] Redirecting from empty data: ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl));
            ctx.res.writeHead(302, {
                Location: encodeURI(path)
            });
            ctx.res.end();
        }
        return null;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (redirectFromEmpty);


/***/ }),

/***/ 64930:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var redirectFromQuery = function(logger) {
    return function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, structure = ref.structure, data = ref.data, ctx = ref.ctx;
        var ref1 = data || {}, _pageRedirect = ref1.pageRedirect, pageRedirect = _pageRedirect === void 0 ? {} : _pageRedirect;
        var redirectUri = pageRedirect === null || pageRedirect === void 0 ? void 0 : pageRedirect.redirectUri;
        var currentUri = structure === null || structure === void 0 ? void 0 : structure.resolvedUrl;
        var _ssr = structure.ssr, ssr = _ssr === void 0 ? "" : _ssr;
        if (redirectUri) {
            logger.info("[Core] Redirecting by ponzi, from ".concat(currentUri, " to ").concat(redirectUri));
            if (!ssr) {
                return {
                    props: {
                        redirect: redirectUri
                    }
                };
            }
            ctx.res.writeHead(301, {
                Location: redirectUri
            });
            ctx.res.end();
        }
        return null;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (redirectFromQuery);


/***/ }),

/***/ 72199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export applyRules */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _opentelemetry_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94843);
/* harmony import */ var lodash_deburr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97329);
/* harmony import */ var lodash_deburr__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_deburr__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);




var rulesFn = {
    lowerCase: function(_, path) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(path.split("?"), 2), uri = ref[0], parameters = ref[1];
        var lowerCase = uri.toLowerCase();
        return parameters ? "".concat(lowerCase, "?").concat(parameters) : lowerCase;
    },
    normalize: function(_, path) {
        return lodash_deburr__WEBPACK_IMPORTED_MODULE_0___default()(path);
    },
    replace: function(param, path) {
        var from = param.from, to = param.to;
        return path.replace(new RegExp(from, "g"), to);
    }
};
var applyRules = function(rules, currentPath) {
    return rules.reduce(function(acc, rule) {
        var ref;
        return ((ref = rulesFn[rule === null || rule === void 0 ? void 0 : rule.name]) === null || ref === void 0 ? void 0 : ref.call(rulesFn, rule, acc)) || acc;
    }, currentPath);
};
/*
  Redirect pages when match in rulesToRedirect from strucutre
  E.g.:
  from: http://localhost:3000/busca/iphone%2012
  to: http://localhost:3000/busca/iphone+12
*/ var redirectFromRules = function(logger) {
    return function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ctx = ref.ctx, structure = ref.structure;
        var span = _opentelemetry_api__WEBPACK_IMPORTED_MODULE_3__/* .trace.getActiveSpan */ .g.getActiveSpan();
        var rulesToRedirect = structure.rulesToRedirect, ssr = structure.ssr;
        if (_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .whereAmI.onClient */ .er.onClient || !ssr || !Array.isArray(rulesToRedirect) || rulesToRedirect.length === 0) {
            return null;
        }
        var url = decodeURIComponent(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl);
        var path = applyRules(rulesToRedirect, url);
        if (path !== url) {
            span === null || span === void 0 ? void 0 : span.addEvent("mixer.redirect.bad.characters", {
                "log.message": "Redirect due invalid characters ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl),
                "log.severity": "info"
            });
            logger.info("[Core] Redirecting from bad character in url: ".concat(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl));
            ctx.res.writeHead(301, {
                Location: encodeURI(path)
            });
            ctx.res.end();
        }
        return null;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (redirectFromRules);


/***/ }),

/***/ 44917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48728);

var redirectToParent = function(ctx, structure) {
    var ssr = structure.ssr;
    var notfoundFallbackUrl = structure.notfoundFallbackUrl;
    var path = (0,_magalu_mixer_structure__WEBPACK_IMPORTED_MODULE_0__/* .parsePlaceholders */ .VD)(notfoundFallbackUrl, structure);
    if (!ssr) {
        return {
            props: {
                redirect: path === null || path === void 0 ? void 0 : path.toLowerCase()
            }
        };
    }
    ctx.res.writeHead(302, {
        Location: path === null || path === void 0 ? void 0 : path.toLowerCase()
    });
    ctx.res.end();
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (redirectToParent);


/***/ }),

/***/ 47737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var removeFiltersAndRedirect = function(ctx, structure) {
    var asPath = structure.asPath, rawPath = structure.rawPath, ssr = structure.ssr;
    var _ref = ctx.query || {}, slug = _ref.slug, currentQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "slug"
    ]);
    var path = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .urlCleanFilters */ .Zq)(asPath, rawPath, currentQuery);
    if (!ssr) {
        return {
            props: {
                redirect: path
            }
        };
    }
    ctx.res.writeHead(302, {
        Location: path
    });
    ctx.res.end();
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (removeFiltersAndRedirect);


/***/ }),

/***/ 67088:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var setCors = function() {
    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (ctx.res) {
        var protocol =  true ? "https://" : 0;
        ctx.res.setHeader("Access-Control-Allow-Origin", "".concat(protocol).concat(ctx.req.headers.host));
        ctx.res.setHeader("Access-Control-Allow-Method", "GET");
        ctx.res.setHeader("Vary", "Accept-Encoding, Origin");
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (setCors);


/***/ }),

/***/ 34948:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var setErrorStatus = function() {
    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, status = arguments.length > 1 ? arguments[1] : void 0, msg = arguments.length > 2 ? arguments[2] : void 0;
    if (ctx === null || ctx === void 0 ? void 0 : ctx.res) ctx.res.statusCode = status;
    return {
        props: {
            errorCode: status,
            errorTitle: msg
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (setErrorStatus);


/***/ }),

/***/ 31328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_shouldRender; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 39 modules
var build_esm = __webpack_require__(48728);
;// CONCATENATED MODULE: ./src/hooks/useConditionalsRender.js


var useConditionalsRender = function(conditionalsRender, data) {
    if (!conditionalsRender) {
        return true;
    }
    if (Array.isArray(conditionalsRender)) {
        return conditionalsRender.reduce(function(acc, render) {
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                (0,build_esm/* parsePlaceholders */.VD)(render, data)
            ]);
        }, []).every(function(render) {
            return !!render;
        });
    }
    var parsed = (0,build_esm/* parsePlaceholders */.VD)(conditionalsRender, data);
    if (parsed.hide !== undefined) {
        return parsed.hide;
    }
    if (parsed.show !== undefined) {
        return parsed.show;
    }
    return !!parsed;
};
/* harmony default export */ var hooks_useConditionalsRender = (useConditionalsRender);

;// CONCATENATED MODULE: ./src/utils/shouldRender.js




var parseSliceToCondition = function(slice, key) {
    if (lodash_default().isPlainObject(slice)) return (0,_define_property/* default */.Z)({}, key, slice);
    if (Array.isArray(slice)) {
        return slice.map(function(item) {
            if (item && !item.includes("||") && !item.includes("!==")) {
                return "".concat(item, "||");
            }
            return item;
        });
    }
    if (slice && !slice.includes("||") && !slice.includes("!==")) return "".concat(slice, "||");
    return slice;
};
var shouldRender = function(props) {
    var ref = props || {}, slice = ref.slice, data = ref.data, structure = ref.structure;
    var ref1 = slice || {}, show = ref1.show, hide = ref1.hide;
    show = parseSliceToCondition(show, "show");
    hide = parseSliceToCondition(hide, "hide");
    if (show && !hooks_useConditionalsRender(show, (0,_object_spread/* default */.Z)({}, structure, data))) return false;
    if (hide && hooks_useConditionalsRender(hide, (0,_object_spread/* default */.Z)({}, structure, data))) return false;
    return true;
};
/* harmony default export */ var utils_shouldRender = (shouldRender);


/***/ }),

/***/ 48728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fl": function() { return /* reexport */ builder; },
  "VD": function() { return /* reexport */ parsePlaceholders_parsePlaceholders; },
  "Bl": function() { return /* reexport */ convertToUrl_termToUrl; }
});

// UNUSED EXPORTS: getPage, getRoute, getServerComponents, getSite, getTheme, handler, jsonRequire, parseRouteData, parseStatements

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/constants.js
var CONTAINS = 'contains';
var EQ = 'eq';
var EXISTS = 'exists';
var FUNCTION_REGEX = /\s+(:do)\s\w+(\.)?\w+[^}]/g;
var GT = 'gt';
var GTE = 'gte';
var IF = '@if';
var INTERPOLATION_FUNCTION_REGEX = /\{\{\w+(\.)?\w+\s+(:do)\s\w+(\.)?\w+[^}]\}\}/g;
var INTERPOLATION_REGEX = /\{\{[^}]+\}\}/g;
var LOWERCASE_REGEX = /\s*(:lowercase)/g;
var LT = 'lt';
var LTE = 'lte';
var NEQ = 'neq';
var NOTCONTAINS = 'notcontains';
var NOTEXISTS = 'notexists';
var PLACEHOLDER_REPLACE_REGEX = /(\{|\})/g;
var REPLACE_REGEX = /\s*(:replace).*[^}]{2}/g;
var STRING_WITH_PLACEHOLDER_REGEX = /"([^"]+)?(\\")?(\{{2}[^"]+\}{2})(\\")?([^"]+)?"/g;
var SWITCH = '@switch';
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parseStatements/parseStatements.js





var _excluded = ["required"];


var operations = function operations(_ref) {
  var op = _ref.op,
    property = _ref.property,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    output = _ref.output;
  return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, CONTAINS, (value == null ? void 0 : value.toString().includes(property)) && output), EQ, property === value && output), EXISTS, function () {
    if ((0,esm_typeof/* default */.Z)(property) !== 'object' && Boolean(property)) {
      return output || true;
    }
    if (lodash_default().isObject(property) && !lodash_default().isEmpty(property)) {
      return output || true;
    }
    return false;
  }()), GT, property > value && output), GTE, property >= value && output), LT, property < value && output), LTE, property <= value && output), NEQ, property !== value && output), NOTCONTAINS, !(value == null ? void 0 : value.toString().includes(property)) && output), NOTEXISTS, function () {
    if ((0,esm_typeof/* default */.Z)(property) !== 'object' && !property) {
      return output || true;
    }
    if (lodash_default().isObject(property) && lodash_default().isEmpty(property)) {
      return output || true;
    }
    return false;
  }())[op];
};
var inventory = function inventory(statement, rules) {
  return (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, IF, function () {
    if (rules.conditionals) {
      var results = rules.conditionals.reduce(function (acc, rule) {
        var operation = operations((0,esm_extends/* default */.Z)({}, rule, {
          output: true
        }));
        acc.push(operation);
        return acc;
      }, []);
      return results.every(Boolean) && rules.output;
    }
    if (Array.isArray(rules)) {
      return rules.reduce(function (acc, _ref2) {
        var _ref2$required = _ref2.required,
          required = _ref2$required === void 0 ? true : _ref2$required,
          rule = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);
        var operation = operations(rule);
        if (operation || required) {
          acc.push(operation);
        }
        return acc;
      }, []);
    }
    return operations(rules);
  }), SWITCH, function () {
    var result;
    rules.forEach(function (rule) {
      if (!result) {
        var operation = operations(rule);
        if (operation) {
          result = operation;
        }
      }
    });
    return result;
  })[statement];
};
var _parseStatements = function parseStatements() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return lodash_default().transform(data, function (result, value, key) {
    if (lodash_default().isPlainObject(value)) {
      var _Object$keys = Object.keys(value),
        _Object$keys2 = (0,slicedToArray/* default */.Z)(_Object$keys, 1),
        statement = _Object$keys2[0];
      var fn = inventory(statement, value[statement]);
      result[key] = fn ? fn() : _parseStatements(value);
    } else {
      result[key] = value;
    }
  });
};

/* harmony default export */ var parseStatements = (_parseStatements);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parseStatements/index.js

// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/utils/parsePlaceholder.js


var encodeHrefPlaceholder = function encodeHrefPlaceholder(placeholder, value, isFullReplacement, acc) {
  if (placeholder === '{{window.location.href}}') {
    var encodedUrl = encodeURIComponent(value);
    return isFullReplacement ? encodedUrl : acc.replace(placeholder, encodedUrl);
  }
  return null;
};
var parsePlaceholder = function parsePlaceholder(placeholders, dataString, source) {
  return placeholders ? placeholders.reduce(function (acc, placeholder) {
    var value = get_default()(source, placeholder.replace(PLACEHOLDER_REPLACE_REGEX, ''), undefined);
    var isFullReplacement = placeholder === dataString;
    if (value !== undefined) {
      var encodedHref = encodeHrefPlaceholder(placeholder, value, isFullReplacement, acc);
      if (encodedHref !== null) return encodedHref;
      return isFullReplacement ? value : acc.replace(placeholder, value);
    }
    return acc;
  }, dataString) : dataString;
};
/* harmony default export */ var utils_parsePlaceholder = (parsePlaceholder);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/utils/removeQuotesChar.js
var removeQuotesChar = function removeQuotesChar(placeholder) {
  return placeholder.slice(1, -1);
};
/* harmony default export */ var utils_removeQuotesChar = (removeQuotesChar);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/utils/index.js


;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseAnd.js


function parseAnd(_ref) {
  var source = _ref.source,
    data = _ref.data,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? '&&' : _ref$separator;
  if (typeof data !== 'string') return data;
  var hasAnd = data.includes(separator);
  if (!hasAnd) return data;
  var items = data.split(separator);
  var parsedItems = items.map(function (item) {
    var placeholders = item.match(INTERPOLATION_REGEX);
    if (!placeholders) return item;
    var parsedPlaceholder = utils_parsePlaceholder(placeholders, item, source);
    if (parsedPlaceholder !== item) return parsedPlaceholder;
    return null;
  });
  return parsedItems.every(Boolean);
}
/* harmony default export */ var plugins_parseAnd = (parseAnd);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseCommon.js


function parseCommon(_ref) {
  var source = _ref.source,
    data = _ref.data;
  if (typeof data !== 'string') return data;
  var placeholders = data.match(INTERPOLATION_REGEX);
  if (!placeholders) return data;
  return utils_parsePlaceholder(placeholders, data, source);
}
/* harmony default export */ var plugins_parseCommon = (parseCommon);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__(49599);
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseDifference.js




function parseDifference(_ref) {
  var source = _ref.source,
    data = _ref.data,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? '!==' : _ref$separator;
  if (typeof data !== 'string') return data;
  var hasDifference = data.includes(separator);
  if (!hasDifference) return data;
  var differences = data.split(separator);
  var parsedDifference = differences.map(function (difference) {
    var placeholders = difference.match(INTERPOLATION_REGEX);
    if (!placeholders) return difference;
    return utils_parsePlaceholder(placeholders, difference, source);
  });
  return uniqWith_default()(parsedDifference, (isEqual_default())).length > 1;
}
/* harmony default export */ var plugins_parseDifference = (parseDifference);
// EXTERNAL MODULE: ../../node_modules/lodash/first.js
var first = __webpack_require__(53237);
var first_default = /*#__PURE__*/__webpack_require__.n(first);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseFallback.js



function parseFallback(_ref) {
  var source = _ref.source,
    data = _ref.data,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? '||' : _ref$separator;
  if (typeof data !== 'string') return data;
  var hasFallBack = data.includes(separator);
  if (!hasFallBack) return data;
  var fallbacks = data.split(separator);
  var parsedFallbacks = fallbacks.map(function (fallback) {
    var placeholders = fallback.match(INTERPOLATION_REGEX);
    if (!placeholders) return fallback;
    var parsedPlaceholder = utils_parsePlaceholder(placeholders, fallback, source);
    if (parsedPlaceholder !== fallback) return parsedPlaceholder;
    return null;
  });
  var filteredFallback = first_default()(parsedFallbacks.filter(Boolean));
  return filteredFallback || '';
}
/* harmony default export */ var plugins_parseFallback = (parseFallback);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseLowercase.js


function parseLowercase(_ref) {
  var source = _ref.source,
    data = _ref.data;
  if (typeof data !== 'string') return data;
  var hasLowercase = data.includes(':lowercase');
  if (!hasLowercase) return data;
  var placeholder = data.replace(LOWERCASE_REGEX, '');
  var placeholders = placeholder.match(INTERPOLATION_REGEX);
  var parsedPlaceholder = utils_parsePlaceholder(placeholders, placeholder, source);
  if (typeof parsedPlaceholder !== 'string') return parsedPlaceholder;
  return parsedPlaceholder.toLowerCase();
}
/* harmony default export */ var plugins_parseLowercase = (parseLowercase);
// EXTERNAL MODULE: ../../node_modules/lodash/replace.js
var replace = __webpack_require__(19759);
var replace_default = /*#__PURE__*/__webpack_require__.n(replace);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseReplace.js




function parseReplace(_ref) {
  var source = _ref.source,
    data = _ref.data;
  if (typeof data !== 'string') return data;
  var hasReplace = data.includes(':replace');
  if (!hasReplace) return data;
  var placeholder = data.replace(REPLACE_REGEX, '');
  var placeholders = placeholder.match(INTERPOLATION_REGEX);
  var _data$match = data.match(REPLACE_REGEX),
    _data$match2 = (0,slicedToArray/* default */.Z)(_data$match, 1),
    replaceData = _data$match2[0];
  var _replaceData$replace$ = replaceData.replace(':replace', '').trim().split(/\s+/g),
    _replaceData$replace$2 = (0,slicedToArray/* default */.Z)(_replaceData$replace$, 2),
    from = _replaceData$replace$2[0],
    _replaceData$replace$3 = _replaceData$replace$2[1],
    to = _replaceData$replace$3 === void 0 ? '' : _replaceData$replace$3;
  var parsedPlaceholder = utils_parsePlaceholder(placeholders, placeholder, source);
  return replace_default()(parsedPlaceholder, from.trim(), to.trim());
}
/* harmony default export */ var plugins_parseReplace = (parseReplace);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/parseFunction.js



function parseFunction(_ref) {
  var source = _ref.source,
    data = _ref.data;
  if (typeof data !== 'string') return data;
  var hasFunction = data.includes(':do');
  if (!hasFunction) return data;
  var _data$match = data.match(INTERPOLATION_FUNCTION_REGEX),
    _data$match2 = (0,slicedToArray/* default */.Z)(_data$match, 1),
    placeholdersFunction = _data$match2[0];
  var placeholder = placeholdersFunction.replace(FUNCTION_REGEX, '');
  var placeholderFunction = utils_parsePlaceholder([placeholder], placeholder, source);
  if (typeof placeholderFunction !== 'function') return data;
  var _placeholdersFunction = placeholdersFunction.match(FUNCTION_REGEX),
    _placeholdersFunction2 = (0,slicedToArray/* default */.Z)(_placeholdersFunction, 1),
    functionData = _placeholdersFunction2[0];
  var placeholderArgs = functionData.replace(':do', '').trim();
  var placeholdersArgs = utils_parsePlaceholder(["{{".concat(placeholderArgs, "}}")], "{{".concat(placeholderArgs, "}}"), source);
  var result = placeholderFunction(placeholdersArgs);
  var dataString = data.replace(INTERPOLATION_FUNCTION_REGEX, result);
  var placeholders = dataString.match(INTERPOLATION_REGEX);
  return utils_parsePlaceholder(placeholders, dataString, source);
}
/* harmony default export */ var plugins_parseFunction = (parseFunction);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/plugins/index.js







var plugins = [[plugins_parseDifference, {
  separator: '!=='
}], [plugins_parseFallback, {
  separator: '||'
}], [plugins_parseAnd, {
  separator: '&&'
}], plugins_parseFunction, plugins_parseReplace, plugins_parseLowercase, plugins_parseCommon];
/* harmony default export */ var parsePlaceholders_plugins = (plugins);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/parsePlaceholders.js






var parseStringWithPlaceholders = function parseStringWithPlaceholders(data, source) {
  return esm/* composite.apply */.h$.apply(void 0, (0,toConsumableArray/* default */.Z)(parsePlaceholders_plugins))({
    data: data,
    source: source
  });
};
var parseObjectWithPlaceholders = function parseObjectWithPlaceholders(data, source) {
  try {
    var dataString = JSON.stringify(data);
    var allPlaceholders = (dataString.match(STRING_WITH_PLACEHOLDER_REGEX) || []).map(utils_removeQuotesChar);
    if (!allPlaceholders.length) return data;
    var parsedStr = allPlaceholders.reduce(function (acc, placeholder) {
      var value = parseStringWithPlaceholders(placeholder, source);
      return acc.replace("\"".concat(placeholder, "\""), JSON.stringify(value).replace(/\\\\"/g, '"'));
    }, dataString);
    return JSON.parse(parsedStr);
  } catch (e) {
    console.error(e);
    return data;
  }
};
var parsePlaceholders = function parsePlaceholders(data, source) {
  if (!data || !source) return data;
  if (typeof data !== 'string') {
    return parseStatements(parseObjectWithPlaceholders(data, source));
  }
  return parseStringWithPlaceholders(data, source);
};
/* harmony default export */ var parsePlaceholders_parsePlaceholders = (parsePlaceholders);
;// CONCATENATED MODULE: ../structure/build-esm/template-engine/parsePlaceholders/index.js

;// CONCATENATED MODULE: ../structure/build-esm/template-engine/index.js


;// CONCATENATED MODULE: ../structure/data/sites.json
var sites_namespaceObject = JSON.parse('[{"id":"magazineluiza-mobile","theme":"magazineluiza","config":{"externalContent":{"header":"{{config.externalContent.header}}","footer":"{{config.externalContent.footer}}"},"domain":"{{config.siteDomain}}","canonicalDomain":"https://www.magazineluiza.com.br","cookieDomain":"{{config.cookieDomain.magazineluiza-mobile}}","loggedUser":"cookies.accountData.id","baseLoginUrl":"{{config.cartUrl.magazineluiza-mobile}}/#/cliente/login/?origin=magazineluiza-mobile","loginUrl":"{{config.cartUrl.magazineluiza-mobile}}/#/cliente/login/?origin=magazineluiza&next={{window.location.href}}","events":["GA","GA4","CloudRetail","Stewie","AllIn","Criteo","Cookies","TikTok","Kwai","RTBHouse","SpotifyAdAnalytics","Bing"],"cartUrl":{"default":"{{config.cartUrl.magazineluiza-mobile}}/","addToBag":"{{config.cartUrl.magazineluiza-mobile}}/#","pickupStore":"{{config.cartUrl.magazineluiza-mobile}}/#/endereco?tipo=retira-loja","oneTouch":"{{config.cartUrl.magazineluiza-mobile}}/#/endereco?tipo=comprar-agora","login":"{{config.cartUrl.magazineluiza-mobile}}/#/cliente/login","typeFloat":"{{config.cartUrl.magazineluiza-mobile}}/#","payment":"{{config.cartUrl.magazineluiza-mobile}}/#/pagamento"},"salesChannelId":"9","images":{"width":470,"height":352},"stewieChannel":"magazine_mobile","review":{"mediaApi":"{{config.review.media-api}}","toggleEnableAttachMedia":"{{config.review.toggleEnableAttachMedia}}","toggleEnableProductReview":"{{config.review.toggleEnableProductReview}}","toogleEnableSellerId":"{{config.review.toogleEnableSellerId}}"}}},{"id":"magazineluiza","theme":"magazineluiza","config":{"externalContent":{"header":"{{config.externalContent.header}}","footer":"{{config.externalContent.footer}}"},"alternateDomain":"https://m.magazineluiza.com.br","domain":"{{config.siteDomain}}","canonicalDomain":"https://www.magazineluiza.com.br","cookieDomain":"{{config.cookieDomain.magazineluiza}}","baseLoginUrl":"{{config.cartUrl.magazineluiza-mobile}}/#/cliente/login/?origin=magazineluiza","loggedUser":"cookies.accountData.id","loginUrl":"{{config.cartUrl.magazineluiza}}/#/cliente/login/?origin=magazineluiza&next={{window.location.href}}","events":["GA","GA4","CloudRetail","Stewie","AllIn","Criteo","Cookies","TikTok","Kwai","RTBHouse","SpotifyAdAnalytics","Bing"],"cartUrl":{"default":"{{config.cartUrl.magazineluiza}}/","pickupStore":"{{config.cartUrl.magazineluiza}}/#/endereco?tipo=retira-loja","oneTouch":"{{config.cartUrl.magazineluiza}}/#/endereco?tipo=comprar-agora","login":"{{config.cartUrl.magazineluiza}}/#/cliente/login","guarantee":"https://www.magazineluiza.com.br/produto/garantia-plus","payment":"{{config.cartUrl.magazineluiza}}/#/pagamento"},"images":{"width":470,"height":352},"salesChannelId":"45","marginBottomScroll":-140,"stewieChannel":"magazine_ecomm","review":{"mediaApi":"{{config.review.media-api}}","toggleEnableAttachMedia":"{{config.review.toggleEnableAttachMedia}}","toggleEnableProductReview":"{{config.review.toggleEnableProductReview}}","toogleEnableSellerId":"{{config.review.toogleEnableSellerId}}"},"cardan":{"isAvailable":"{{config.cardan.isAvailable}}"}}},{"id":"parceiromagalu-mobile","basePath":"/:storeId","theme":"parceiromagalu","config":{"domain":"{{config.parceiromagalu.domain}}","canonicalDomain":"{{config.parceiromagalu.domain}}","cookieDomain":"{{config.cookieDomain.parceiromagalu-mobile}}","events":["GA","Stewie","Cookies","PmdCartCookie","PmdActions"],"cartUrl":{"default":"{{config.cartUrl.parceiromagalu-mobile}}/","pickupStore":"{{config.cartUrl.parceiromagalu-mobile}}/#/endereco?tipo=retira-loja","oneTouch":"{{config.cartUrl.parceiromagalu-mobile}}/#/endereco","login":"{{config.cartUrl.parceiromagalu-mobile}}/#/cliente/login"},"sanchoUrl":"{{config.parceiromagalu.sanchoUrl}}","salesChannelId":"7","stewieChannel":"magazine_voce"}},{"id":"parceiromagalu","basePath":"/:storeId","theme":"parceiromagalu","config":{"domain":"{{config.parceiromagalu.domain}}","canonicalDomain":"{{config.parceiromagalu.domain}}","cookieDomain":"{{config.cookieDomain.parceiromagalu-mobile}}","baseLoginUrl":"{{config.cartUrl.parceiromagalu}}/#/cliente/login/?origin=magazineluiza","loggedUser":"cookies.accountData.id","loginUrl":"{{config.cartUrl.parceiromagalu}}/#/cliente/login/?origin=magazinevoce&next={{window.location.href}}","events":["GA","Stewie","Cookies","PmdCartCookie","PmdActions"],"cartUrl":{"default":"{{config.cartUrl.parceiromagalu}}/","pickupStore":"{{config.cartUrl.parceiromagalu}}/#/endereco?tipo=retira-loja","oneTouch":"{{config.cartUrl.parceiromagalu}}/#/endereco","login":"{{config.cartUrl.parceiromagalu}}/#/cliente/login","guarantee":"https://www.magazineluiza.com.br/produto/garantia-plus"},"sanchoUrl":"{{config.parceiromagalu.sanchoUrl}}","salesChannelId":"4","stewieChannel":"magazine_voce","marginBottomScroll":-140,"images":{"width":470,"height":352}}},{"id":"parceiromagaluempresas-customer","basePath":"/:storeId","rules":[{"hosts":["pme:3000","mixer-pme.luizalabs.com","mixer-pme.magalu.com","pmedivulgador.magazineluiza.com.br"]}],"theme":"parceiromagaluempresas-customer","config":{"domain":"https://pmedivulgador.magazineluiza.com.br/","canonicalDomain":"https://pmedivulgador.magazineluiza.com.br/","cookieDomain":"{{config.cookieDomain.parceiromagaluempresas-customer}}","events":["GA","Cookies","PmeCartCookie"],"cartUrl":{"default":"{{config.cartUrl.parceiromagaluempresas-customer}}/","pickupStore":"{{config.cartUrl.parceiromagaluempresas-customer}}#/endereco?tipo=retira-loja","oneTouch":"{{config.cartUrl.parceiromagaluempresas-customer}}#/endereco","login":"{{config.cartUrl.parceiromagaluempresas-customer}}#/cliente/login"},"salesChannelId":"190","stewieChannel":"magazine_mobile_pme_customer"}},{"id":"parceiromagaluempresas-seller","basePath":"/:storeId","rules":[{"hosts":["pme-seller:3000","mixer-pme-seller.luizalabs.com","mixer-pme-seller.magalu.com","www.mixer-pme-seller.magalu.com"]}],"theme":"parceiromagaluempresas-seller","config":{"domain":"https://mixer-pme-seller.magalu.com","canonicalDomain":"https://mixer-pme-seller.magalu.com","cookieDomain":"{{config.cookieDomain.parceiromagaluempresas-seller}}","events":["GA","Cookies"],"salesChannelId":"190","stewieChannel":"magazine_mobile_pme_seller"}},{"id":"lojinha","theme":"lojinha","config":{"cookieDomain":".lojinha.com.br","events":["GA"]}},{"id":"blog","basePath":"/blog-da-lu","hosts":["blog:3000","magazineluiza.com.br/blog-da-lu"],"theme":"blog","config":{"domain":"https://magazineluiza.com.br/blog-da-lu","canonicalDomain":"https://www.magazineluiza.com.br","cookieDomain":"{{config.cookieDomain.default}}","events":["GA"]}},{"id":"blog-mobile","basePath":"/blog-da-lu","hosts":["blog-mobile:3000","m.magazineluiza.com.br/blog-da-lu"],"theme":"blog","config":{"domain":"https://m.magazineluiza.com.br/blog-da-lu","canonicalDomain":"https://www.magazineluiza.com.br","cookieDomain":"{{config.cookieDomain.default}}","events":["GA"]}},{"id":"mini-apps","theme":"magazineluiza","config":{"isMiniApp":true,"desktopSiteDomain":"https://www.magazineluiza.com.br","domain":"http://mixer-mini-apps.magazineluiza.com.br","canonicalDomain":"http://mixer-mini-apps.magazineluiza.com.br","cookieDomain":"{{config.cookieDomain.default}}","loggedUser":"cookies.accountData.id","events":["GA","MiniAppSdk"],"images":{"width":470,"height":352},"stewieChannel":"magazine_mobile","review":{"mediaApi":"{{config.review.media-api}}","toggleEnableAttachMedia":"{{config.review.toggleEnableAttachMedia}}","toggleEnableProductReview":"{{config.review.toggleEnableProductReview}}","toogleEnableSellerId":"{{config.review.toogleEnableSellerId}}"},"salesChannelId":"9"}}]');
;// CONCATENATED MODULE: ../structure/build-esm/builder/getSite.js


var getSite = function getSite(siteId) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var availableSites = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sites_namespaceObject;
  var currentSite = siteId && availableSites.find(function (site) {
    return siteId === site.id;
  });
  if (!currentSite) {
    return currentSite;
  }
  return parsePlaceholders_parsePlaceholders(currentSite, {
    config: config.serverRuntimeConfig
  });
};
/* harmony default export */ var builder_getSite = (getSite);
// EXTERNAL MODULE: fs (ignored)
var fs_ignored_ = __webpack_require__(39937);
var fs_ignored_default = /*#__PURE__*/__webpack_require__.n(fs_ignored_);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(15153);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
;// CONCATENATED MODULE: ../structure/build-esm/utils/jsonRequire.js
var jsonRequire_dirname = "/";


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


/* harmony default export */ var jsonRequire = (function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(module, fallback) {
    var moduleAbsolutePath, fallbackModuleAbsolutePath;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          moduleAbsolutePath = path_browserify_default().join(jsonRequire_dirname.split('packages')[0], 'packages/structure/data', module);
          if (!(fallback && !fs_ignored_default().existsSync(moduleAbsolutePath))) {
            _context.next = 8;
            break;
          }
          fallbackModuleAbsolutePath = path_browserify_default().join(jsonRequire_dirname.split('packages')[0], 'packages/structure/data', fallback);
          _context.t0 = JSON;
          _context.next = 6;
          return fs_ignored_default().promises.readFile(fallbackModuleAbsolutePath);
        case 6:
          _context.t1 = _context.sent;
          return _context.abrupt("return", _context.t0.parse.call(_context.t0, _context.t1));
        case 8:
          _context.t2 = JSON;
          _context.next = 11;
          return fs_ignored_default().promises.readFile(moduleAbsolutePath);
        case 11:
          _context.t3 = _context.sent;
          return _context.abrupt("return", _context.t2.parse.call(_context.t2, _context.t3));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
// EXTERNAL MODULE: ../../node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(12782);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parseCategoryId.js


var parseCategoryId_excluded = ["categoryId", "subCategoryId"];
var parseCategoryId = function parseCategoryId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var categoryId = _ref.categoryId,
    subCategoryId = _ref.subCategoryId,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parseCategoryId_excluded);
  var parsedParams = (0,esm_extends/* default */.Z)({}, params);
  if (categoryId) {
    parsedParams.categoryId = categoryId.toUpperCase();
  }
  if (subCategoryId) {
    parsedParams.subCategoryId = subCategoryId.toUpperCase();
  }
  return (0,esm_extends/* default */.Z)({}, parsedParams);
};
/* harmony default export */ var parseRouteData_parseCategoryId = (parseCategoryId);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parseFilters.js




var parseFilters_excluded = ["filters"];

var getReviewMin = function getReviewMin(value) {
  return (value.match(/\d+/g) || []).map(Number).sort(function (a, b) {
    return b - a;
  }).pop() || 0;
};
var getPriceMinMax = function getPriceMinMax(value) {
  return value.split(esm/* FILTER_PRICE_SLUG_SEPARATOR */.E_).map(Number);
};
var filterStringParser = function filterStringParser(filterString) {
  if (!filterString || typeof filterString !== 'string') {
    return [];
  }
  return filterString.split(esm/* FILTERS_SEPARATOR */.JJ).reduce(function (filters, filter) {
    var _filter$split = filter.split(esm/* FILTER_TYPE_SLUG_SEPARATOR */.It),
      _filter$split2 = (0,slicedToArray/* default */.Z)(_filter$split, 2),
      type = _filter$split2[0],
      valueStr = _filter$split2[1];
    if (type && valueStr) {
      if (type === esm/* PRICE_FILTER */.Bj) {
        var _getPriceMinMax = getPriceMinMax(valueStr),
          _getPriceMinMax2 = (0,slicedToArray/* default */.Z)(_getPriceMinMax, 2),
          minPrice = _getPriceMinMax2[0],
          maxPrice = _getPriceMinMax2[1];
        return [].concat((0,toConsumableArray/* default */.Z)(filters), [{
          max: maxPrice,
          min: minPrice,
          type: type
        }]);
      }
      if (type === esm/* REVIEW_FILTER */.By) {
        return [].concat((0,toConsumableArray/* default */.Z)(filters), [{
          max: esm/* REVIEW_FILTER_MAX */.X7,
          min: getReviewMin(valueStr),
          type: type
        }]);
      }
      var values = valueStr.split(esm/* FILTER_SLUG_SEPARATOR */.jS);
      var newFilters = values.map(function (value) {
        return {
          type: type,
          value: type === esm/* CATEGORY_FILTER */.wk ? value.toUpperCase() : value
        };
      });
      return [].concat((0,toConsumableArray/* default */.Z)(filters), (0,toConsumableArray/* default */.Z)(newFilters));
    }
    return filters;
  }, []);
};
var parseFilters = function parseFilters() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filterString = _ref.filters,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parseFilters_excluded);
  var filters = filterStringParser(filterString);
  if (params == null ? void 0 : params.categoryId) {
    filters.push({
      origin: 'url',
      type: 'category',
      value: params.categoryId.toUpperCase()
    });
  }
  if (params == null ? void 0 : params.subCategoryId) {
    filters.push({
      origin: 'url',
      type: 'subcategory',
      value: params.subCategoryId.toUpperCase()
    });
  }
  if (params == null ? void 0 : params.brandId) {
    filters.push({
      origin: 'url',
      type: 'brand',
      value: params.brandId.toLowerCase()
    });
  }
  if (params == null ? void 0 : params.sellerId) {
    filters.push({
      origin: 'url',
      type: 'seller',
      value: params.sellerId
    });
  }
  if (params == null ? void 0 : params.selectionId) {
    filters.push({
      origin: 'url',
      type: 'selection',
      value: params.selectionId
    });
  }
  if (filterString === undefined && !filters.length) return params;
  return (0,esm_extends/* default */.Z)({}, params, {
    filters: filters
  });
};
/* harmony default export */ var parseRouteData_parseFilters = (parseFilters);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parsePage.js


var parsePage_excluded = ["page"];

var parsePage = function parsePage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentPage = _ref.page,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parsePage_excluded);
  if (!currentPage) return (0,esm_extends/* default */.Z)({}, params);
  var page = (0,esm/* parsePageFilter */.iz)(currentPage);
  return (0,esm_extends/* default */.Z)({}, params, {
    page: page
  });
};
/* harmony default export */ var parseRouteData_parsePage = (parsePage);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parsePartnerStoreName.js



var parsePartnerStoreName_excluded = ["storeId"];

var parsePartnerStoreName = function parsePartnerStoreName() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? 'magazine' : _ref$separator,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'pmdStoreName' : _ref$as,
    strict = _ref.strict;
  return function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var storeId = _ref2.storeId,
      params = (0,objectWithoutProperties/* default */.Z)(_ref2, parsePartnerStoreName_excluded);
    if (!storeId) return params;
    var storeName = storeId.split(separator)[1];
    if (storeName) return (0,esm_extends/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, as, (0,esm/* capitalize */.kC)(storeName)), "storeId", storeId), params);
    if (!strict) return (0,esm_extends/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, as, (0,esm/* capitalize */.kC)(storeId)), "storeId", storeId), params);
    return (0,esm_extends/* default */.Z)({
      storeId: storeId
    }, params);
  };
};
/* harmony default export */ var parseRouteData_parsePartnerStoreName = (parsePartnerStoreName);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parseTerm.js


var parseTerm_excluded = ["term"];
var termStrParser = function termStrParser(term) {
  if (!term || typeof term !== 'string' || !term.trim()) {
    return '';
  }
  return term.replace(/([^+])\+(?=[^+])/g, '$1 ').replace(/\+{3,}/g, ' + ').replace(/\+{2,}/g, '+').trim();
};
var parseTerm = function parseTerm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var termStr = _ref.term,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parseTerm_excluded);
  if (termStr === undefined) return params;
  var term = termStrParser(termStr);
  return (0,esm_extends/* default */.Z)({}, params, {
    term: term
  });
};
/* harmony default export */ var parseRouteData_parseTerm = (parseTerm);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parseSellerId.js



var parseSellerId_excluded = ["sellerId", "seller_id"];
var parseSellerId = function parseSellerId() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sellerId = _ref.sellerId,
    sellerIdQS = _ref.seller_id,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parseSellerId_excluded);
  var uniqueSellerId = sellerId || sellerIdQS;
  if (Array.isArray(uniqueSellerId)) {
    var _uniqueSellerId = uniqueSellerId;
    var _uniqueSellerId2 = (0,slicedToArray/* default */.Z)(_uniqueSellerId, 1);
    uniqueSellerId = _uniqueSellerId2[0];
  }
  return (0,esm_extends/* default */.Z)({}, params, uniqueSellerId ? {
    sellerId: uniqueSellerId
  } : {});
};
/* harmony default export */ var parseRouteData_parseSellerId = (parseSellerId);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/parseDeeplinkParams.js



var parseDeeplinkParams_excluded = ["deeplink"];
var parseDeeplinkParams = function parseDeeplinkParams(_ref) {
  var deeplink = _ref.deeplink,
    params = (0,objectWithoutProperties/* default */.Z)(_ref, parseDeeplinkParams_excluded);
  var newParams;
  if (!deeplink) {
    return params;
  }
  var decodedDeeplink = decodeURIComponent(deeplink);
  var keyValues = decodedDeeplink.split('&');
  var deeplinkParams = keyValues.reduce(function (acc, item) {
    var _item$split = item.split('='),
      _item$split2 = (0,slicedToArray/* default */.Z)(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];
    acc[key] = value;
    return acc;
  }, {});
  if (deeplinkParams.product_sku) {
    newParams = {
      productId: deeplinkParams.product_sku
    };
  }
  if (deeplinkParams.seller_id) {
    newParams = (0,esm_extends/* default */.Z)({}, newParams, {
      sellerId: deeplinkParams.seller_id
    });
  }
  return (0,esm_extends/* default */.Z)({}, newParams, params);
};
/* harmony default export */ var parseRouteData_parseDeeplinkParams = (parseDeeplinkParams);
;// CONCATENATED MODULE: ../structure/build-esm/builder/parseRouteData/index.js











var parsers = [parseRouteData_parseCategoryId, parseRouteData_parseFilters, parseRouteData_parseTerm, parseRouteData_parsePage, parseRouteData_parseSellerId, parseRouteData_parsePartnerStoreName({
  as: 'pmdStoreName',
  separator: 'magazine'
}), parseRouteData_parsePartnerStoreName({
  as: 'pmeStoreName',
  separator: 'parceiro',
  strict: true
}), esm/* parseQuestionsPageQuery */.ds, esm/* parseReviewsPageQuery */.NE, parseRouteData_parseDeeplinkParams];
var parseRouteData = function parseRouteData(params) {
  var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var routeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  try {
    var parsedParams = parsers.reduce(function (parsed, parser) {
      return parser(parsed, routeId);
    }, params);
    return mergeWith_default()(parsedParams, previous, function (obj, src) {
      if (Array.isArray(obj)) {
        return uniqWith_default()(obj.concat(src), (isEqual_default()));
      }
      return src;
    });
  } catch (e) {
    console.error(e);
    return {};
  }
};

/* harmony default export */ var builder_parseRouteData = (parseRouteData);
;// CONCATENATED MODULE: ../structure/build-esm/builder/getRoute.js


function getRoute_regeneratorRuntime() { "use strict"; getRoute_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


var getRoute = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getRoute_regeneratorRuntime().mark(function _callee() {
    var _ref2,
      site,
      routeId,
      uri,
      _ref2$query,
      query,
      _ref2$params,
      params,
      siteRoutes,
      route,
      _site$basePath,
      basePath,
      _args = arguments;
    return getRoute_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, site = _ref2.site, routeId = _ref2.routeId, uri = _ref2.uri, _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? {} : _ref2$params;
          if (!(!(site == null ? void 0 : site.id) || !uri)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", undefined);
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return jsonRequire("/sites/".concat(site.id, "/routes.json"));
        case 6:
          siteRoutes = _context.sent;
          route = siteRoutes.find(function (siteRoute) {
            return routeId === siteRoute.id;
          });
          _site$basePath = site.basePath, basePath = _site$basePath === void 0 ? '' : _site$basePath;
          route.path = "".concat(basePath).concat(route.path);
          route.query = builder_parseRouteData(query, {}, routeId);
          route.route = builder_parseRouteData(params, route == null ? void 0 : route.query, routeId);
          route.parsedBasePath = basePath ? "/".concat(params[basePath.replace(/\/:?/, '')]) : basePath;
          return _context.abrupt("return", route);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](3);
          console.error(_context.t0);
          return _context.abrupt("return", undefined);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 16]]);
  }));
  return function getRoute() {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var builder_getRoute = (getRoute);
// EXTERNAL MODULE: ../../node_modules/lodash/merge.js
var merge = __webpack_require__(98537);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// CONCATENATED MODULE: ../structure/build-esm/builder/getTheme.js



var getTheme_excluded = ["extends"];
function getTheme_regeneratorRuntime() { "use strict"; getTheme_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


var _getTheme = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getTheme_regeneratorRuntime().mark(function _callee() {
    var _ref2,
      suffix,
      themeId,
      _ref2$child,
      child,
      path,
      fallback,
      themeData,
      parent,
      theme,
      mergedTheme,
      _args = arguments;
    return getTheme_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, suffix = _ref2.suffix, themeId = _ref2.themeId, _ref2$child = _ref2.child, child = _ref2$child === void 0 ? {} : _ref2$child;
          _context.prev = 1;
          path = "/themes/".concat(themeId).concat(suffix ? "-".concat(suffix) : '', ".json");
          fallback = "/themes/".concat(themeId, ".json");
          _context.next = 6;
          return jsonRequire(path, fallback);
        case 6:
          themeData = _context.sent;
          parent = themeData["extends"], theme = (0,objectWithoutProperties/* default */.Z)(themeData, getTheme_excluded);
          mergedTheme = merge_default()({}, theme, child);
          return _context.abrupt("return", parent ? _getTheme({
            child: mergedTheme,
            themeId: parent
          }) : mergedTheme);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", undefined);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function getTheme() {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var getTheme = (_getTheme);
;// CONCATENATED MODULE: ../structure/build-esm/utils/deepMergeCustom.js

var deepMergeCustom = function deepMergeCustom(objValue, srcValue) {
  if (Array.isArray(objValue) && Array.isArray(srcValue)) {
    return objValue.map(function (objEl) {
      var sameIdSrcEl = srcValue.find(function (srcEl) {
        return srcEl.id === objEl.id;
      });
      if (sameIdSrcEl) return merge_default()(objEl, sameIdSrcEl);
      return objEl;
    }).concat(srcValue.filter(function (sEl) {
      return !objValue.find(function (e) {
        return e.id === sEl.id;
      });
    }));
  }
  return undefined;
};
/* harmony default export */ var utils_deepMergeCustom = (deepMergeCustom);
;// CONCATENATED MODULE: ../structure/build-esm/builder/getTemplate.js



var getTemplate_excluded = ["extends"];
function getTemplate_regeneratorRuntime() { "use strict"; getTemplate_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var _getTemplate = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getTemplate_regeneratorRuntime().mark(function _callee() {
    var _ref2,
      site,
      template,
      _ref2$child,
      child,
      templateJson,
      parent,
      templateData,
      mergedTemplate,
      _args = arguments;
    return getTemplate_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, site = _ref2.site, template = _ref2.template, _ref2$child = _ref2.child, child = _ref2$child === void 0 ? {} : _ref2$child;
          _context.prev = 1;
          if (!(!site || !template)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", undefined);
        case 4:
          _context.next = 6;
          return jsonRequire("/sites/".concat(site, "/templates/").concat(template, ".json"));
        case 6:
          templateJson = _context.sent;
          parent = templateJson["extends"], templateData = (0,objectWithoutProperties/* default */.Z)(templateJson, getTemplate_excluded);
          mergedTemplate = mergeWith_default()(templateData, child, utils_deepMergeCustom);
          return _context.abrupt("return", parent ? _getTemplate({
            child: mergedTemplate,
            site: site,
            template: parent
          }) : mergedTemplate);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", undefined);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function getTemplate() {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var getTemplate = (_getTemplate);
;// CONCATENATED MODULE: ../structure/build-esm/builder/getServerComponents.js


function getServerComponents_regeneratorRuntime() { "use strict"; getServerComponents_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }




var applyOverride = function applyOverride(components, overrides) {
  return components.map(function (component) {
    var override = overrides.find(function (item) {
      return item.id === component.id;
    });
    return merge_default()(component, override);
  });
};
var _getServerComponents = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getServerComponents_regeneratorRuntime().mark(function _callee() {
    var _ref2,
      site,
      component,
      _ref2$override,
      override,
      _ref2$childComponents,
      childComponents,
      _yield$jsonRequire,
      parent,
      components,
      mergedComponents,
      _args = arguments;
    return getServerComponents_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, site = _ref2.site, component = _ref2.component, _ref2$override = _ref2.override, override = _ref2$override === void 0 ? [] : _ref2$override, _ref2$childComponents = _ref2.childComponents, childComponents = _ref2$childComponents === void 0 ? {} : _ref2$childComponents;
          _context.prev = 1;
          if (!(!site || !component)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", override);
        case 4:
          _context.next = 6;
          return jsonRequire("/sites/".concat(site, "/server-components/").concat(component, ".json"));
        case 6:
          _yield$jsonRequire = _context.sent;
          parent = _yield$jsonRequire["extends"];
          components = _yield$jsonRequire.components;
          mergedComponents = mergeWith_default()({
            components: components
          }, {
            components: childComponents
          }, utils_deepMergeCustom);
          if (!parent) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", _getServerComponents({
            childComponents: mergedComponents.components,
            component: parent,
            override: override,
            site: site
          }));
        case 12:
          return _context.abrupt("return", (override == null ? void 0 : override.length) ? applyOverride(mergedComponents.components, override) : mergedComponents.components);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", override);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 15]]);
  }));
  return function getServerComponents() {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var getServerComponents = (_getServerComponents);
;// CONCATENATED MODULE: ../structure/build-esm/builder/getPage.js





var getPage_excluded = ["extends", "components"],
  _excluded2 = ["layout", "before", "after", "metaTags", "head"];
function getPage_regeneratorRuntime() { "use strict"; getPage_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var parseGroups = function parseGroups(items) {
  return items.reduce(function (result, item) {
    if (item.disabled) return result;
    if (!item.grid_id) {
      result.push(item);
    } else {
      var found = result.find(function (i) {
        return i.grid_id === item.grid_id;
      });
      if (found) {
        found.components.push(item);
      } else {
        result.push({
          components: [item],
          grid_id: item.grid_id,
          type: 'group'
        });
      }
    }
    return result;
  }, []);
};
var parseServerComponents = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getPage_regeneratorRuntime().mark(function _callee(site, parsedComponents, component) {
    var parent, override, singleComponent, serverComponents;
    return getPage_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          parent = component["extends"], override = component.components, singleComponent = (0,objectWithoutProperties/* default */.Z)(component, getPage_excluded);
          if (!parent) {
            _context.next = 6;
            break;
          }
          _context.next = 4;
          return getServerComponents({
            component: parent,
            override: override,
            site: site
          });
        case 4:
          serverComponents = _context.sent;
          return _context.abrupt("return", [].concat((0,toConsumableArray/* default */.Z)(parsedComponents), (0,toConsumableArray/* default */.Z)(serverComponents)));
        case 6:
          return _context.abrupt("return", [].concat((0,toConsumableArray/* default */.Z)(parsedComponents), [singleComponent]));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function parseServerComponents(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _getPageData = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(getPage_regeneratorRuntime().mark(function _callee2(site, page) {
    var pageData, extendedPage;
    return getPage_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return jsonRequire("/sites/".concat(site, "/pages/").concat(page, ".json"));
        case 2:
          pageData = _context2.sent;
          if (!pageData["extends"]) {
            _context2.next = 8;
            break;
          }
          _context2.next = 6;
          return _getPageData(site, pageData["extends"]);
        case 6:
          extendedPage = _context2.sent;
          return _context2.abrupt("return", (0,esm_extends/* default */.Z)({}, extendedPage, pageData));
        case 8:
          return _context2.abrupt("return", pageData);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getPageData(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var getPage = function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)(getPage_regeneratorRuntime().mark(function _callee4() {
    var _ref4,
      site,
      page,
      template,
      pageData,
      fullTemplateObject,
      _fullTemplateObject$l,
      templateLayout,
      _fullTemplateObject$b,
      templateBefore,
      _fullTemplateObject$a,
      templateAfter,
      _fullTemplateObject$m,
      templateMetaTags,
      _fullTemplateObject$h,
      templateHead,
      otherTemplateProps,
      compList,
      components,
      head,
      _args4 = arguments;
    return getPage_regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref4 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, site = _ref4.site, page = _ref4.page, template = _ref4.template;
          _context4.prev = 1;
          if (!(!site || !page)) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", undefined);
        case 4:
          _context4.next = 6;
          return _getPageData(site, page);
        case 6:
          pageData = _context4.sent;
          _context4.next = 9;
          return getTemplate({
            site: site,
            template: template
          });
        case 9:
          _context4.t0 = _context4.sent;
          if (_context4.t0) {
            _context4.next = 12;
            break;
          }
          _context4.t0 = {};
        case 12:
          fullTemplateObject = _context4.t0;
          _fullTemplateObject$l = fullTemplateObject.layout, templateLayout = _fullTemplateObject$l === void 0 ? {} : _fullTemplateObject$l, _fullTemplateObject$b = fullTemplateObject.before, templateBefore = _fullTemplateObject$b === void 0 ? [] : _fullTemplateObject$b, _fullTemplateObject$a = fullTemplateObject.after, templateAfter = _fullTemplateObject$a === void 0 ? [] : _fullTemplateObject$a, _fullTemplateObject$m = fullTemplateObject.metaTags, templateMetaTags = _fullTemplateObject$m === void 0 ? [] : _fullTemplateObject$m, _fullTemplateObject$h = fullTemplateObject.head, templateHead = _fullTemplateObject$h === void 0 ? [] : _fullTemplateObject$h, otherTemplateProps = (0,objectWithoutProperties/* default */.Z)(fullTemplateObject, _excluded2);
          _context4.next = 16;
          return [].concat((0,toConsumableArray/* default */.Z)(templateBefore), (0,toConsumableArray/* default */.Z)(pageData.components || []), (0,toConsumableArray/* default */.Z)(templateAfter), [{
            id: 'loading',
            name: 'Loader'
          }]).reduce(function () {
            var _ref5 = (0,asyncToGenerator/* default */.Z)(getPage_regeneratorRuntime().mark(function _callee3(parsingComponents, component) {
              var parsedComponents;
              return getPage_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return parsingComponents;
                  case 2:
                    parsedComponents = _context3.sent;
                    return _context3.abrupt("return", parseServerComponents(site, parsedComponents, component));
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x6, _x7) {
              return _ref5.apply(this, arguments);
            };
          }(), Promise.resolve([]));
        case 16:
          compList = _context4.sent;
          components = parseGroups(compList);
          head = [].concat((0,toConsumableArray/* default */.Z)(templateHead), (0,toConsumableArray/* default */.Z)(pageData.head || [])).filter(function (_ref6) {
            var disabled = _ref6.disabled;
            return !disabled;
          });
          return _context4.abrupt("return", (0,esm_extends/* default */.Z)({}, otherTemplateProps, pageData, {
            components: components,
            head: head,
            layout: (0,esm_extends/* default */.Z)({}, templateLayout, pageData.layout || {}),
            metaTags: [].concat((0,toConsumableArray/* default */.Z)(pageData.metaTags || []), (0,toConsumableArray/* default */.Z)(templateMetaTags))
          }));
        case 22:
          _context4.prev = 22;
          _context4.t1 = _context4["catch"](1);
          console.error(_context4.t1);
          return _context4.abrupt("return", undefined);
        case 26:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 22]]);
  }));
  return function getPage() {
    return _ref3.apply(this, arguments);
  };
}();
/* harmony default export */ var builder_getPage = (getPage);
;// CONCATENATED MODULE: ../structure/build-esm/builder/index.js



function builder_regeneratorRuntime() { "use strict"; builder_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }





var builder = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(builder_regeneratorRuntime().mark(function _callee(_ref) {
    var themeSuffix, uri, params, query, siteId, routeId, userAgent, config, componentId, site, route, theme, page, serverComponents, searchParams;
    return builder_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          themeSuffix = _ref.themeSuffix, uri = _ref.uri, params = _ref.params, query = _ref.query, siteId = _ref.siteId, routeId = _ref.routeId, userAgent = _ref.userAgent, config = _ref.config;
          componentId = query.componentId;
          site = builder_getSite(siteId, config);
          _context.t0 = site == null ? void 0 : site.id;
          if (!_context.t0) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return builder_getRoute({
            params: params,
            query: query,
            routeId: routeId,
            site: site,
            uri: uri
          });
        case 7:
          _context.t0 = _context.sent;
        case 8:
          route = _context.t0;
          _context.t1 = site == null ? void 0 : site.theme;
          if (!_context.t1) {
            _context.next = 14;
            break;
          }
          _context.next = 13;
          return getTheme({
            suffix: themeSuffix,
            themeId: (route == null ? void 0 : route.theme) || (site == null ? void 0 : site.theme)
          });
        case 13:
          _context.t1 = _context.sent;
        case 14:
          theme = _context.t1;
          _context.t2 = (site == null ? void 0 : site.id) && (route == null ? void 0 : route.id) && !componentId;
          if (!_context.t2) {
            _context.next = 20;
            break;
          }
          _context.next = 19;
          return builder_getPage({
            page: route.id,
            site: site.id,
            template: route.template
          });
        case 19:
          _context.t2 = _context.sent;
        case 20:
          page = _context.t2;
          _context.t3 = componentId;
          if (!_context.t3) {
            _context.next = 26;
            break;
          }
          _context.next = 25;
          return getServerComponents({
            component: componentId,
            site: site.id
          });
        case 25:
          _context.t3 = _context.sent;
        case 26:
          serverComponents = _context.t3;
          searchParams = Object.keys((route == null ? void 0 : route.query) || {}).length ? "?".concat(new URLSearchParams(query).toString()) : '';
          return _context.abrupt("return", (0,esm_extends/* default */.Z)({}, page || {}, serverComponents ? {
            serverComponents: serverComponents
          } : {}, {
            asPath: uri,
            basePath: route == null ? void 0 : route.parsedBasePath,
            canonicalPath: "".concat(uri).concat(searchParams),
            config: site == null ? void 0 : site.config,
            id: route == null ? void 0 : route.id,
            name: route == null ? void 0 : route.name,
            "private": Boolean(route == null ? void 0 : route["private"]),
            query: (route == null ? void 0 : route.query) || {},
            rawPath: route == null ? void 0 : route.path,
            route: route == null ? void 0 : route.route,
            site: site == null ? void 0 : site.id,
            theme: theme,
            userAgent: userAgent || ''
          }));
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function builder(_x) {
    return _ref2.apply(this, arguments);
  };
}();

;// CONCATENATED MODULE: ../structure/build-esm/handler.js


function handler_regeneratorRuntime() { "use strict"; handler_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

var handler = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(handler_regeneratorRuntime().mark(function _callee(req, res) {
    var _req$query, host, uri, deviceType, structure;
    return handler_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _req$query = req.query, host = _req$query.h, uri = _req$query.u, deviceType = _req$query.d;
          _context.next = 4;
          return builder({
            deviceType: deviceType,
            host: host,
            uri: uri
          });
        case 4:
          structure = _context.sent;
          if (!(structure && structure.route && structure.theme && structure.components)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", res.status(200).json(structure));
        case 7:
          return _context.abrupt("return", res.status(404).end('Not found'));
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", res.status(500).end(_context.t0));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function handler(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var build_esm_handler = ((/* unused pure expression or super */ null && (handler)));
;// CONCATENATED MODULE: ../structure/build-esm/convertToUrl/termToUrl.js
var termToUrl = function termToUrl() {
  var term = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
  return term.trim().replace(/ \+ /g, '+++').replace(/([^+ ])\+(?=[^+]|$)/g, '$1++').replace(/(\s|\/|-)/g, '+');
};
/* harmony default export */ var convertToUrl_termToUrl = (termToUrl);
;// CONCATENATED MODULE: ../structure/build-esm/convertToUrl/index.js

;// CONCATENATED MODULE: ../structure/build-esm/utils/index.js

;// CONCATENATED MODULE: ../structure/build-esm/index.js







/***/ })

}]);